import { useEffect, useState } from "react";
import { api } from "../lib/api";

// True when the admin session cookie is still valid. Pass a dep (e.g. the
// current pathname) to re-check as the curator moves around the site.
export function useCurator(dep) {
  const [curator, setCurator] = useState(false);
  useEffect(() => {
    let alive = true;
    api
      .get("/admin/verify")
      .then(() => { if (alive) setCurator(true); })
      .catch(() => { if (alive) setCurator(false); });
    return () => { alive = false; };
  }, [dep]);
  return curator;
}
